module.exports = __webpack_public_path__ + "static/img/4_1_1.794e851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_1.png
// module id = ZMZ6
// module chunks = 1